import { render, staticRenderFns } from "./user-visualizer-v2.vue?vue&type=template&id=74c37113&scoped=true&"
import script from "./user-visualizer-v2.vue?vue&type=script&lang=js&"
export * from "./user-visualizer-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c37113",
  null
  
)

export default component.exports